module.exports = __webpack_public_path__ + "1b873e828de9b9d9413c642f01eb068e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2018/midyear/afi/color.png
// module id = 1876
// module chunks = 1